import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getOfflineModelsStatus } from '../../api/documentAPI';

// Ikona ⓘ, ktorá po kliknutí rozbalí/zbalí popis (klik namiesto hoveru -> funguje aj na mobile).
const InfoToggle = ({ open, onToggle, label }) => (
    <button
        type="button"
        className={`proc-info-btn${open ? ' open' : ''}`}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); onToggle(); }}
        aria-expanded={open}
        aria-label={label}
        title={label}
    >
        <span className="material-symbols-outlined">info</span>
    </button>
);

// Voľba spracovania ako malá karta (rádio): ikona, názov, krátky podtitul.
const ModeCard = ({ selected, icon, title, sub, onSelect }) => (
    <button
        type="button"
        role="radio"
        aria-checked={selected}
        className={`proc-card${selected ? ' selected' : ''}`}
        onClick={onSelect}
    >
        <span className="proc-card-dot" aria-hidden="true"></span>
        <span className="proc-card-body">
            <span className="proc-card-title">
                <span className="material-symbols-outlined">{icon}</span><span className="proc-card-name">{title}</span>
            </span>
            <span className="proc-card-sub">{sub}</span>
        </span>
    </button>
);

// Spôsob spracovania dokumentov priečinka: offline (docling na serveri, predvolené) alebo
// Azure Document Intelligence (platené). OCR skenov má zmysel len offline — DI ich číta sám.
const ProcessingModeFields = ({ docIntelligence, imgProcessing, onChange, isEdit }) => {

    const [t, ] = useTranslation('global');
    const [modeInfo, setModeInfo] = useState(false);
    const [ocrInfo, setOcrInfo] = useState(false);
    const [models, setModels] = useState(null);   // stav modelov pre offline PDF (null = nevieme)

    // pri voľbe Offline over, či sú modely nainštalované; počas sťahovania obnovuj
    useEffect(() => {
        if (docIntelligence) return undefined;
        let alive = true, timer = null;
        const load = () => getOfflineModelsStatus()
            .then((s) => {
                if (!alive) return;
                setModels(s || null);
                if (s && s.Downloading) timer = setTimeout(load, 5000);
            })
            .catch(() => { if (alive) setModels(null); });
        load();
        return () => { alive = false; if (timer) clearTimeout(timer); };
    }, [docIntelligence]);

    const setMode = (di) => onChange({ docIntelligence: di, imgProcessing });

    return (
        <div className="proc-mode">
            <div className="proc-head">
                <span className="proc-head-label">{t('procMode')}</span>
                <InfoToggle open={modeInfo} onToggle={() => setModeInfo(v => !v)} label={t('procMode')} />
            </div>

            <div className="proc-cards" role="radiogroup" aria-label={t('procMode')}>
                <ModeCard selected={!docIntelligence} icon="dns" title={t('procOffline')}
                          sub={t('procOfflineSub')} onSelect={() => setMode(false)} />
                <ModeCard selected={!!docIntelligence} icon="cloud" title={t('procDI')}
                          sub={t('procDISub')} onSelect={() => setMode(true)} />
            </div>

            {modeInfo && (
                <div className="proc-info-box">{docIntelligence ? t('procDIHint') : t('procOfflineHint')}</div>
            )}

            {!docIntelligence && typeof models?.Ready === 'boolean' && !models.Ready && (
                <div className={`proc-models-warn${models.Downloading ? ' downloading' : ''}`}>
                    <span className="material-symbols-outlined">{models.Downloading ? 'downloading' : 'warning'}</span>
                    <span>{models.Downloading ? t('procModelsDownloading') : t('procModelsMissing')}</span>
                </div>
            )}

            {!docIntelligence && (
                <>
                    <div className="proc-ocr-row">
                        <label className="proc-ocr">
                            <input
                                type="checkbox"
                                checked={!!imgProcessing}
                                onChange={(e) => onChange({ docIntelligence, imgProcessing: e.target.checked })}
                            />
                            <span className="proc-ocr-track" aria-hidden="true"></span>
                            <span className="proc-ocr-text">{t('procOcr')}</span>
                        </label>
                        <InfoToggle open={ocrInfo} onToggle={() => setOcrInfo(v => !v)} label={t('procOcr')} />
                    </div>
                    {ocrInfo && <div className="proc-info-box">{t('procOcrHint')}</div>}
                </>
            )}

            {isEdit && <span className="proc-change-note">{t('procChangeNote')}</span>}
        </div>
    );
};

export default ProcessingModeFields;
